export default function snakeToCamel(str: string): string {
  return str.replace(/(_\w)/g, (k) => k[1].toUpperCase())
}
